/*
 * File: /src/services/knowledgeTypeService.js
 * Author: AdBase, Inc.
 * Copyright (c) 2026 AdBase, Inc.
 */

import { authedAxios } from '../shared/axiosWrapper';
import { S2_KNOWLEDGE_TYPES_PATH } from '../constants';

export default {
  fetchKnowledgeTypes(params = {}) {
    return authedAxios.get(S2_KNOWLEDGE_TYPES_PATH, {
      params: {
        filter: params.filters,
        limit: params.limit,
        offset: params.offset,
        sort: params.sort,
      },
    });
  },
  fetchKnowledgeType(id) {
    return authedAxios.get(S2_KNOWLEDGE_TYPES_PATH + id);
  },
  createKnowledgeType(payload) {
    return authedAxios.post(S2_KNOWLEDGE_TYPES_PATH, payload);
  },
  // The API takes the whole record on update, not a partial
  updateKnowledgeType(id, payload) {
    return authedAxios.put(S2_KNOWLEDGE_TYPES_PATH + id, payload);
  },
  deleteKnowledgeType(id) {
    return authedAxios.delete(S2_KNOWLEDGE_TYPES_PATH + id);
  },
};
